export  function leadConfirmationCall(){
     setHeaderText();
    document.body.style.overflow = "visible"
    var MlyCleaning = sessionStorage.getItem("MlyCleaning");
    var MlyHomeDetails = sessionStorage.getItem("MlyHomeDetails");
    var firstName = sessionStorage.getItem("CFirstName");
    var lastName = sessionStorage.getItem("CLastName");
    var jobDate = sessionStorage.getItem("CJobDate");
    var Time = sessionStorage.getItem("CTime");
    var serviceRequest = sessionStorage.getItem("CServiceRequest");
    var email = sessionStorage.getItem("CEmail");
    var phone = sessionStorage.getItem("CPhone");
    var street = sessionStorage.getItem("CAddress");
    var city = sessionStorage.getItem("CCity");
    var state = sessionStorage.getItem("CState");
    var pincode = sessionStorage.getItem("CPostalCode");
    var modifier = sessionStorage.getItem('ServiceModifierValue');
    var serviceModalEnable = sessionStorage.getItem('ServiceModalEnable');
    var concept_id = sessionStorage.getItem("conceptID");
    var fullname = firstName + " " + lastName;
    var fulladdress = street + ' ' + city + ',' + state + ' ' + pincode;
    var logoSrc= sessionStorage.getItem("logo");
    let phoneNumber =  sessionStorage.getItem('phoneNumber');
    var dt = $('<dt>'); var dt1 = $('<dt>'); var dt2 = $('<dt>'); var dt3 = $('<dt>'); var dt4 = $('<dt>'); var dt5 = $('<dt>'); var dt6 = $('<dt>'); var dt7 = $('<dt>'); var dt8 = $('<dt>');
    var dd = $('<dd>'); var dd1 = $('<dd>'); var dd2 = $('<dd>'); var dd3 = $('<dd>'); var dd4 = $('<dd>'); var dd5 = $('<dd>'); var dd6 = $('<dd>'); var dd7 = $('<dd>'); var dd8 = $('<dd>');
    $('.result-stack-logo').empty();
    $('.result-stack-logo').append('<img src="' + logoSrc + '" alt="" width="164" height="76" />');
    $('.scheduler-modal .modal-header-two').css('padding-bottom','2rem');
    $('.retHome').css({"font-size": "16px", "color" : "#4377bd" , "text-align":"center" , "font-weight":700 , "pointer-events": "auto" , "margin":"auto"});
    $('body').removeClass('modal-open');
    if (sessionStorage.getItem("CLeadOnly") != 'true') {
        $(dt).html('Date:');
        $(dd).html(jobDate);
        $(dt1).html('Time:');
        $(dd1).html(Time);
        if($("#confirmation-title-schedule").val() != null && $("#confirmation-title-schedule").val() != "")
        $(".confirmation-data .primary-title").text($("#confirmation-title-schedule").val() as any);
        else
        $(".confirmation-data .primary-title").addClass("d-none");
        if($("#confirmation-subtext-schedule").val() != null && $("#confirmation-subtext-schedule").val() != "")
        $(".confirmation-data .sub-title").text($("#confirmation-subtext-schedule").val() as any);
        else
        $(".confirmation-data .sub-title").addClass("d-none");
    }
    else{
        if($("#confirmation-title-lead").val() != null && $("#confirmation-title-lead").val() != "")
        $(".confirmation-data .primary-title").text($("#confirmation-title-lead").val() as any);
        else
        $(".confirmation-data .primary-title").addClass("d-none");
        if($("#confirmation-subtext-lead").val() != null && $("#confirmation-subtext-lead").val() != "")
        $(".confirmation-data .sub-title").text($("#confirmation-subtext-lead").val() as any);
        else
        $(".confirmation-data .sub-title").addClass("d-none");
    }
    if($('#conceptCode').val() == "MLY" && modifier !='Commercial') {
        
    }else{
        if(!serviceModalEnable && concept_id !='24'){
            $(dt2).html('Service Request:');
            $(dd2).html(serviceRequest);
        }
    }
    if (window.location.href.indexOf("molly") > -1)  {
        if(modifier !='Commercial'){
            var MlyCleaning = sessionStorage.getItem("MlyCleaning");
            var MlyFrequency = sessionStorage.getItem("MlyFrequency");
            if(localStorage.getItem("selectedAboutHome") == "onetime"){
                $(dt7).html('Move-In/Move-Out Cleaning:');
                $(dd7).html(MlyCleaning);
            }
            else{
                $(dt7).html('Frequency:');
                $(dd7).html(MlyFrequency);
            }
            // $(dt7).html('Move-In/Move-Out Cleaning:');
            // $(dd7).html(MlyCleaning);
        }
    }
    if (window.location.href.indexOf("molly") > -1) {
        if(modifier =='Commercial'){
            $(dt8).html('Office Details:');
            $(dd8).html(MlyHomeDetails);
        }else{
            $(dt8).html('Home Details:');
            $(dd8).html(MlyHomeDetails);
        }
        
    }
    $(dt3).html('Name:');
    $(dd3).html(fullname);
    $(dt4).html('Email:');
    $(dd4).html(email);
    $(dt5).html('Phone:');
    $(dd5).html(phone);
    $(dt6).html('Service Address:');
    $(dd6).html(fulladdress);
    $('.results-phone-num').text(phoneNumber);
    $('.confirmation-data .appointment .text-sm').append(dt).append(dd);
    $('.confirmation-data .appointment .text-sm').append(dt1).append(dd1);
    $('.confirmation-data .appointment .text-sm').append(dt2).append(dd2);
    $('.confirmation-data .appointment .text-sm').append(dt7).append(dd7);
    $('.confirmation-data .appointment .text-sm').append(dt8).append(dd8);
    $('.confirmation-data .contact .text-sm').append(dt3).append(dd3);
    $('.confirmation-data .contact .text-sm').append(dt4).append(dd4);
    $('.confirmation-data .contact .text-sm').append(dt5).append(dd5);
    $('.confirmation-data .contact .text-sm').append(dt6).append(dd6);

    //USER STORY 76501
    //if($('#conceptCode').val() == "MLY" && modifier !='Commercial') {
}
//}

 function setHeaderText() {
    //var frequency = localStorage.getItem("selectedAboutHome");
    var brands = localStorage.getItem("country") == 'CA' ? "/ca/en-ca/_assets/brands.json" : "/us/en-us/_assets/brands.json";
    
    $.getJSON(brands, function (result:any) { 
        if (result.length > 0) {
            var items = $.grep(result, function (e:any) { return e.id === localStorage.getItem("ConceptCalledId") });
            
            if(items.length) {
                
                // var title_Lead = frequency == "recurring" ? items[0].confirmation_title_lead_recurring : items[0].confirmation_title_lead_onetime;
                // var subtitle_Lead = frequency == "recurring" ? items[0].confirmation_subtext_lead_recurring : items[0].confirmation_subtext_lead_onetime;
                // var title_schedule = frequency == "recurring" ? items[0].confirmation_title_schedule_recurring : items[0].confirmation_title_schedule_onetime;
                // var subtitle_schedule = frequency == "recurring" ? items[0].confirmation_subtext_schedule_recurring : items[0].confirmation_subtext_schedule_onetime;
                    var confirmTitle = JSON.parse(sessionStorage.getItem("CLeadOnly")) ? items[0].confirmation_title_lead : items[0].confirmation_title_schedule;
                    var confirmSubText = JSON.parse(sessionStorage.getItem("CLeadOnly")) ? items[0].confirmation_subtext_lead : items[0].confirmation_subtext_schedule;
                    sessionStorage.removeItem('confirmTitle');
                    sessionStorage.removeItem('confirmSubText');
                    sessionStorage.setItem('confirmTitle', confirmTitle);
                    sessionStorage.setItem('confirmSubText', confirmSubText);

                // if (sessionStorage.getItem("CLeadOnly") != 'true') {
                //     $('.confirmation-data .primary-title').text(title_schedule);
                //     $('.confirmation-data .sub-title').text(subtitle_schedule);	
                // }
                // else{
                //     $('.confirmation-data .primary-title').text(title_Lead);
                //     $('.confirmation-data .sub-title').text(subtitle_Lead);	
                // }
                $('.confirmation-data .primary-title').text(confirmTitle);
                $('.confirmation-data .sub-title').text(confirmSubText);
                $(".confirmation-data .primary-title").removeClass("d-none");
                $('.confirmation-data .sub-title').removeClass("d-none");			
            }
        }
    });
}